const businessLandingES = {
	hero: {
		title: "Tu negocio creciendo, sin estrés",
		subtitle:
			"Si tienes un negocio o quieres empezar uno, Sin Fila automatiza reservas, recordatorios, la gestión de tu equipo, y te ayuda a atraer más clientes. ",
		primaryCta: "Registrar negocio gratis",
		storeText: "Disponible en iOS · Android",
		noteStrong: "Comienza tu prueba gratuita de 14 días ahora",
		noteRest: " • Configura tu negocio en solo 15 min • Sin complicaciones ni contratos • Cancela en cualquier momento",
	},

	problem: {
		title: "El problema real",
		subtitle: "¿Te pasa esto?",
		items: [
			"📱 Respondes WhatsApp todo el día (y de noche)",
			"📆 Horarios cruzados o espacios vacíos",
			"🚶 Clientes llegan, ven fila larga… y se van",
			"📊 No saber cuántos clientes atendiste este mes",
			"🌐 Te cuesta atraer nuevos clientes y aumentar la visibilidad de tu negocio",
		],
		itemspart2: ["⏳ Si no hay nadie → pierdes tiempo.", "😤 Si hay demasiada fila → pierdes clientes."],
		description: "💸 Cada cliente que se va por la fila es dinero perdido.",
		highlight: "👉 Muchos negocios pierden hasta 20% de sus ingresos por gestión de citas, tiempos muertos y clientes que se van al esperar.",
	},

	didYouKnow: {
		title: "Sabías que...",
		items: [
			"Más del 70% de los clientes prefieren reservar online si pueden",
			"Automatizar citas te saca del WhatsApp todo el día",
			"Tener visibilidad online permite atraer hasta un 40% más de nuevos clientes sin pagar anuncios",
			"Centralizar los datos de ventas te ayuda a tomar mejores decisiones para crecer",
		],
		highlight: "✅ Centralizar horarios, personal y reservas en un solo lugar permite una operación más ordenada, eficiente y fácil de gestionar en el día a día",
	},

	solution: {
		title: "Sin Fila lo soluciona",
		points: [
			{
				title: "Nunca pierdas una reserva",
				desc: "Todas tus citas, confirmaciones y recordatorios en un solo lugar.",
			},
			{
				title: "Atrae nuevos clientes y llena tu agenda",
				desc: "Muestra tu negocio a más clientes en nuestro marketplace.",
			},
			{
				title: "Ahorra tiempo gestionando tu negocio y tu equipo",
				desc: "Administra tus servicios y los calendarios de tu personal sin esfuerzo.",
			},
			{
				title: "Reservas fáciles para tus clientes",
				desc: "Tus clientes reservan, modifican y reciben recordatorios automáticamente.",
			},
		],
	},

	businessBenefits: {
		title: "Beneficios para negocios",
		subtitle: "Organiza tu agenda, automatiza citas y evita perder clientes.",
		items: [
			"Recibir reservas online 24/7",
			"Confirmaciones automáticas y recordatorios",
			"Horarios claros y sin cruces",
			"Perfil público para conseguir clientes nuevos",
			"Menos tiempo en WhatsApp — más tiempo trabajando",
		],
	},

	customerBenefits: {
		title: "Beneficios para clientes",
		subtitle: "Reserva tu cita en segundos, sin llamadas ni espera.",
		items: [
			"Ver disponibilidad real",
			"Reservar al instante",
			"Recibir recordatorios automáticos",
			"Reprogramar o cancelar sin estrés",
			"Encontrar barberías, salones y más cerca de ti",
		],
	},

	howToStart: {
		title: "Cómo empezar",
		steps: [
			{ title: "Crea tu cuenta gratis", desc: "Regístrate en minutos y configura tu negocio." },
			{ title: "Añade tus servicios y tu equipo", desc: "Personaliza tu perfil y horarios." },
			{ title: "Empieza a recibir reservas", desc: "Y deja que Sin Fila haga el resto." },
		],
	},

	pricing: {
		title: "Un plan simple, todo incluido",
		planTitle: "Paga solo por lo que usas:",
		planItems: [
			"💳 $15 USD / mes — primer usuario",
			"👥 $8 USD / mes — cada uno de tus siguientes 4 usuarios",
			"🎁 Gratis para todos los usuarios adicionales",
		],
		capNote: "Tu factura ya no aumenta después de 4 usuarios — de ahí en adelante, todos son gratis.",
		note: "Sin contratos. Sin cargos escondidos. Cancela cuando quieras.",
		autoTitle: "Pagar Sin Fila es simple y automático:",
		autoItems: [
			"Aceptamos tarjetas de crédito y débito directamente en la plataforma",
			"El cobro se realiza mensualmente de forma automática",
			"Puedes cancelar en cualquier momento, sin contratos ni permanencias",
		],
		priceNote: "Prueba gratuita de 14 días",
		featuresTitle: "Todo incluido, sin importar tu plan",
		features: [
			"Reservas ilimitadas",
			"0% de comisiones",
			"Tienda personalizada en el marketplace de Sin Fila",
			"App móvil disponible en Apple y Android",
			"Calendario inteligente, cero dobles reservas",
			"Gestión de equipo sin complicaciones",
			"Reservas presenciales, a domicilio y virtuales",
			"Enlace de reserva personalizado",
			"Notificaciones automáticas en tiempo real",
			"Reportes de rendimiento del negocio",
			"Lista de contactos de clientes",
			"Seguimiento de ingresos por servicio, personal y origen",
			"Programa de referidos para negocios",
			"Facturación mensual automática",
			"Soporte dedicado",
		],
	},

	referral: {
		title: "Comparte Sin Fila. Obtén recompensas.",
		subtitle: "¿Conoces un negocio que necesita esto? Envíale tu código — ambos salen ganando.",
		sectionLabel: "Cómo funciona",
		cards: [
			{
				icon: "💵",
				tone: "gold",
				title: "Si refieres un negocio",
				desc: "Sin límite.Sin trucos. $15 USD de crédito cada vez que alguien que refieras haga su primer pago.",
				bullets: [
					"Sin límite — refiere tantos negocios como quieras, y gana $15 USD por cada uno.",
					"Tu recompensa se aplica automáticamente a tu cuenta.",
				],
			},
			{
				icon: "🎁",
				tone: "sky",
				title: "Si fuiste referido",
				desc: "Obtienes 2 semanas extra gratis — 28 días en total en lugar de 14 — para que tengas más tiempo de probar Sin Fila antes de que se te cobre algo.",
			},
		],
		ctaButton: "Obtener mi código de referido",
		microCopy: "Sin límite. Sin trucos. Solo $15 USD cada vez que alguien que refieras se una.",
		moreDetailsLink: "Ver todos los detalles del programa",
	},

	testimonials: {
		title: "Lo que dicen nuestros clientes",
		items: [
			{
				quote:
					"Sin Fila me ha hecho mucho más fácil organizar mis citas y mi día. Mis clientes pueden reservar directamente, incluso para servicios a domicilio, y yo tengo todo organizado en un solo lugar.",
				name: "Sara",
				role: "Profesional de bienestar",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila me ha ayudado a tener mi agenda mucho más organizada y a reducir el tiempo que paso coordinando citas. También me permite que nuevos clientes me descubran y puedan reservar conmigo fácilmente.",
				name: "Pedro",
				role: "Barbero",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila me ayudó a organizar mucho mejor mi salón. Ahora puedo ver y gestionar las agendas de todo mi equipo desde un solo lugar, y es mucho más fácil coordinar los horarios y las citas.",
				name: "Maria",
				role: "Dueña de salón",
				location: "Santo Domingo",
			},
		],
	},

	final: {
		text: "Empieza gratis ahora y aprovecha nuestro programa de referidos",
		button: "Registrar negocio gratis",
	},

	contact: {
		question: "¿Tienes preguntas? Estamos para ayudarte.",
		website: "reservasinfila.com",
		email: "hola@reservasinfila.com",
		phone: "+1 (514) 758-6041",
	},

	misc: {
  badge: "Sin Fila para negocios",
  freeMonthsTag: "🎁 Meses gratis",
  labelReferral: "Programa de Referidos",
  labelChallenge: "El Problema",
  labelResearch: "¿Sabías que...?",
  labelHowItWorks: "Cómo Funciona",
  labelPricing: "Precios",
  labelTestimonials: "Testimonios",
  priceNote: "/ mes por usuario",  // move from pricing.priceNote
},
};

export default businessLandingES;
